import { render, staticRenderFns } from "./pinggu-edit.vue?vue&type=template&id=a9cb9ff8&scoped=true&"
import script from "./pinggu-edit.vue?vue&type=script&lang=ts&"
export * from "./pinggu-edit.vue?vue&type=script&lang=ts&"
import style0 from "./pinggu-edit.vue?vue&type=style&index=0&id=a9cb9ff8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9cb9ff8",
  null
  
)

export default component.exports